import { Box, styled } from "@mui/material";
import {
    HeroSection,
    FeaturesSection,
    DashboardSection,
    BannerSection,
    GuaranteeSection,
    FAQSection
} from "../components";

import type { Feature } from "../components/FeaturesSection";

const PageContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
}));

const ContentWrapper = styled(Box)(() => ({
    width: "100%",
    marginTop: "-50px",
    borderRadius: "50px 50px 0 0",
    backgroundColor: "var(--background-white)",
    position: "relative",
    zIndex: 2,
    display: "flex",
    justifyContent: "center",
    "@media (max-width: 600px)": {
        marginTop: "-32px",
        borderRadius: "32px 32px 0 0",
    },
}));

const ContentInner = styled(Box)(() => ({
    width: "100%",
    maxWidth: "1440px",
    padding: "106px 120px 60px 120px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "56px",
    "@media (max-width: 600px)": {
        padding: "32px 16px 32px 16px",
        gap: "32px",
    },
}));

const features: Feature[] = [
    {
        title: "Комплаенс до операции",
        description:
            "Каждая транзакция проходит проверку заранее.",
    },
    {
        title: "Полный контроль средств",
        description:
            "Ваши деньги всегда остаются под вашим управлением.",
    },
    {
        title: "Минимум формальностей",
        description:
            "Мы берём на себя проверки, документы и координацию.",
    },
];



export const WalletPage = () => {
    return (
        <PageContainer>
            <HeroSection
                backgroundImage="/assets/wallet-hero.webp"
                title="Свобода капитала без блокировок"
                subtitle="Единый финансовый кабинет для частных лиц"
            />
            <ContentWrapper>
                <ContentInner>
                    <GuaranteeSection
                        title="Сфера Кошелёк"
                        description="это цифровой кошелёк нового поколения для управления личными финансами за рубежом. Вы платите не за перевод — вы платите за гарантию того, что операция пройдёт успешно."
                    />
                    <FeaturesSection features={features} />
                    <DashboardSection
                        title="Международные переводы и расчёты"
                        description="Title"
                        imageSrc="/assets/wallet-dashboard-1.webp"
                    />
                    <DashboardSection
                        reverse
                        title="Покупка и хранение цифровых активов"
                        description="Title"
                        imageSrc="/assets/wallet-dashboard-2.webp"
                    />
                    <DashboardSection
                        title="Платёжные инструменты и карты"
                        description="Title"
                        imageSrc="/assets/wallet-dashboard-3.webp"
                    />
                    <DashboardSection
                        reverse
                        title="Онлайн-верификация и комплаенс"
                        description="Title"
                        imageSrc="/assets/wallet-dashboard-4.webp"
                    />

                    <DashboardSection
                        title="Сопровождение операций и поддержка 24/7"
                        description="Title"
                        imageSrc="/assets/wallet-dashboard-5.webp"
                    />

                    <BannerSection
                        title="Готовы вернуть контроль над своими активами?"
                        imageSrc="/assets/wallet-banner.webp"
                        imageAlt="GTC Platform"
                    />
                    <FAQSection />
                </ContentInner>
            </ContentWrapper>
        </PageContainer>
    );
};
